"use client";
import React from "react";
import { AutocompleteGameCard } from "modules/cards/model/card";
import { SetIcon, SetPromoIndicator } from "modules/common/components/SetIcon";
import { useSets } from "modules/common/hooks/useSets";
import { cn } from "utils/utils";
import { formatCurrency } from "utils/currency";
import {
  priceForFinish,
  primaryAvailableFinish,
} from "modules/cards/model/finishBehavior";

interface Props {
  option: AutocompleteGameCard;
  highlighted: boolean;
  itemProps: React.HTMLAttributes<HTMLLIElement>;
}

export function AutocompleteListItem({
  option,
  highlighted,
  itemProps: { className, ...restItemProps },
}: Props) {
  const { getSetName } = useSets();
  const finish = primaryAvailableFinish(option.finishes);
  const price = finish ? priceForFinish(option.price, finish) : 0;

  return (
    <li
      {...restItemProps}
      className={cn(
        "relative cursor-default select-none px-3 py-2",
        highlighted
          ? "bg-primary text-primary-content"
          : className || "bg-base-100 text-base-content",
        className
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex max-w-[70%] flex-col gap-2">
          <span className="truncate font-medium" title={option?.name}>
            {option?.name}
          </span>
          {price > 0 && (
            <span
              className={cn(
                "text-sm",
                highlighted ? "text-primary-content/70" : "text-base-content/70"
              )}
            >
              {formatCurrency(price, option.price.currency)}
            </span>
          )}
        </div>
        <div className="flex flex-col items-end gap-2">
          <SetPromoIndicator
            isPromo={option?.isPromo}
            markerClassName={cn(
              highlighted && "fill-primary-content stroke-primary"
            )}
          >
            <div
              className="tooltip tooltip-left tooltip-info"
              data-tip={getSetName(option.setCode, option.game)}
            >
              <SetIcon
                setCode={option.setCode}
                game={option.game}
                size="lg"
                className={cn(
                  highlighted ? "text-primary-content" : "text-secondary",
                  "inline-block"
                )}
              />
            </div>
          </SetPromoIndicator>
          <span
            className={cn(
              "text-xs",
              highlighted ? "text-primary-content/70" : "text-base-content/70"
            )}
          >
            {option?.number}
          </span>
        </div>
      </div>
    </li>
  );
}
